module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "purchaseOrders"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-title-block form-title-principal",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("Usuarios")]), _vm._v(" "), _c('div', {
    staticClass: "form-title-block",
    staticStyle: {
      "margin-left": "79%"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Añadir Usuario\n                   ")])], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "modalReevaluation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalReevaluation"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkServer(_vm.typeUser)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Registro de Usuarios")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReevaluetion
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-tabs",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de usuario :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeUser),
      expression: "typeUser"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cliente"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "operador"
    }
  }, [_vm._v("Operador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "administrador"
    }
  }, [_vm._v("Administrador")])])]), _vm._v(" "), ((_vm.typeUser === 'cliente') || (_vm.typeUser === 'administrador') || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombre :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": 50,
      "id": "firstname",
      "aria-describedby": "firstname",
      "placeholder": "Ingrese el  nombre",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseName) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Apellido :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": 100,
      "id": "lastname",
      "aria-describedby": "lastname",
      "placeholder": "Ingrese el apellido",
      "required": ""
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseLast) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseLast))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateUser,
    attrs: {
      "type": "email",
      "id": "email",
      "aria-describedby": "email",
      "placeholder": "Ingresa el email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseUser) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseUser))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Username :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateUserName,
    attrs: {
      "type": "text",
      "id": "username",
      "aria-describedby": "username",
      "placeholder": "Ingresa el username",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseUserName) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseUserName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.typeUser === 'cliente') || (_vm.typeUser === 'administrador') || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("DNI :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dni),
      expression: "dni"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dni",
      "aria-describedby": "dni",
      "placeholder": "Ingresa el DNI",
      "required": ""
    },
    domProps: {
      "value": (_vm.dni)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dni = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Teléfono :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "phone3",
      "aria-describedby": "phone",
      "placeholder": "Numero de teléfono",
      "required": ""
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responsePhone != '') ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePhone))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código de País :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country_code),
      expression: "country_code"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country_code = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listCountry), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.dial_code
      }
    }, [_vm._v(_vm._s(option.dial_code) + " - " + _vm._s(option.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), ((_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de operador :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operator_type),
      expression: "operator_type"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "id": "operator_type",
      "name": "operator_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operator_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Envio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Recepción")])])]) : _vm._e(), _vm._v(" "), ((_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar ciudad :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city_id),
      expression: "city_id"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "id": "city_id",
      "name": "city_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.city_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Miami")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Buenos Aires")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("Lima")])])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Género :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sexo),
      expression: "sexo"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "id": "genre",
      "name": "sexo",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sexo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "true",
      "disabled": "disabled"
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Femenino")])]), _vm._v(" "), (_vm.responseGenre) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseGenre))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de nacimiento :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseDate) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseDate))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contraseña :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Ingrese la contraseña",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responsePass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePass))]) : _vm._e(), _vm._v(" "), (_vm.response2Pass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.response2Pass))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Repita contraseña :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkPassword),
      expression: "checkPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password2",
      "placeholder": "Repita la contraseña",
      "required": ""
    },
    domProps: {
      "value": (_vm.checkPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseCheck) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseCheck))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.typeUser.length > 0) ? _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit",
      "id": "submit"
    }
  }, [_vm._v("Registrar Usuario")])]) : _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Registrar Usuario")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content",
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('form', {
    staticClass: "formulario2",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionUser),
      expression: "selectionUser"
    }],
    attrs: {
      "type": "radio",
      "id": "cli"
    },
    domProps: {
      "value": 'clientes',
      "checked": _vm._q(_vm.selectionUser, 'clientes')
    },
    on: {
      "change": function($event) {
        _vm.selectionUser = 'clientes'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cli"
    }
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionUser),
      expression: "selectionUser"
    }],
    attrs: {
      "type": "radio",
      "id": "oper"
    },
    domProps: {
      "value": 'operadores',
      "checked": _vm._q(_vm.selectionUser, 'operadores')
    },
    on: {
      "change": function($event) {
        _vm.selectionUser = 'operadores'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "oper"
    }
  }, [_vm._v("Operadores")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionUser),
      expression: "selectionUser"
    }],
    attrs: {
      "type": "radio",
      "id": "admin"
    },
    domProps: {
      "value": 'administradores',
      "checked": _vm._q(_vm.selectionUser, 'administradores')
    },
    on: {
      "change": function($event) {
        _vm.selectionUser = 'administradores'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "admin"
    }
  }, [_vm._v("Administradores")])])])])])], 1), _vm._v(" "), _c('div', {}, [(_vm.selectionUser == 'clientes') ? _c('chart1') : _vm._e(), _vm._v(" "), (_vm.selectionUser == 'operadores') ? _c('chart2') : _vm._e(), _vm._v(" "), (_vm.selectionUser == 'administradores') ? _c('chart3') : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bdbf7ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/userListView.vue
// module id = 1869
// module chunks = 1